import type OlMap from "ol/Map";

import { useTranslation } from "../../i18n";
import { MapOverlay } from "../map-overlays/MapOverlay";
import { CloseIcon } from "../map-tools/icons";

import { IdentifyFeature } from "./IdentifyFeature";
import type { IdentifyFeatureItem, IdentifyPopupState } from "./types";

export function IdentifyPopup({
  map,
  identify,
  onZoomToFeature,
  onClose,
}: {
  map: OlMap;
  identify: IdentifyPopupState;
  onZoomToFeature: (item: IdentifyFeatureItem) => Promise<void>;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const items = identify.items.slice(0, 4);

  return (
    <MapOverlay map={map} offset={[0, -12]} position={identify.position}>
      <div
        className="identify-popup"
        role="dialog"
        aria-label={t("identify.dialogLabel")}
      >
        <div className="identify-popup-header">
          <strong>{t("identify.title")}</strong>
          {identify.items.length > 1 && <span>{identify.items.length}</span>}
          <button
            className="identify-popup-close"
            type="button"
            aria-label={t("identify.close")}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onClose();
            }}
          >
            <CloseIcon />
          </button>
        </div>

        <div className="identify-popup-body" aria-live="polite">
          {identify.loading ? (
            <div className="loading-row">
              <span className="spinner" />
              {identify.message}
            </div>
          ) : items.length ? (
            items.map((item) => (
              <IdentifyFeature
                key={`${item.layerId}-${item.id}`}
                item={item}
                onZoomToFeature={onZoomToFeature}
              />
            ))
          ) : (
            <div className="identify-empty">{identify.message}</div>
          )}
        </div>
      </div>
    </MapOverlay>
  );
}
